import React from "react";
import { useISalesModel } from "../salesModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useISalesModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Statistic Analysis"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Sales Volume"]}</span>
        {/* <span style={{ color: "#7F7F7F" }}>{"统计分析"} </span>
        <span style={{ color: "#000" }}>/ {"出入汇总表"}</span> */}
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "单据编号",
            placeholder: Locale["Document No."],
            fieldName: "saleCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "客户名称",
            placeholder: Locale["Customer"],
            fieldName: "customerName",
            size: "small",
        },
        {
            type: SearchTypeEnum.RangePicker,
            // span: 4,
            // // placeholder: "出/入库日期",
            // placeholder: Locale["Stock-io Time"],
            // fieldName: "name",
            // size: "small",
            fieldName: "",
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}